module.exports = __webpack_public_path__ + "img/bank-is.8006443e.svg";